// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { clientLogger } from '@seedplanner/logger';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { useEffect } from 'react';

interface DateTransitionOptions {
  timezone: string;
  onTransition?: (newDate: Dayjs) => void;
}

export function useDateTransition({ timezone, onTransition }: DateTransitionOptions) {
  useEffect(() => {
    const checkDateTransition = () => {
      const now = dayjs().tz(timezone);
      onTransition?.(now);

      // Schedule next check
      const tomorrow = now.add(1, 'day').startOf('day');
      const msUntilMidnight = tomorrow.diff(now);
      const hoursUntilMidnight = Math.round(msUntilMidnight / 1000 / 60 / 60);
      clientLogger.info({ message: 'Setting next date transition timeout', hoursUntilMidnight });
      timeout = setTimeout(checkDateTransition, msUntilMidnight);
    };

    // Calculate initial timeout
    const now = dayjs().tz(timezone);
    const tomorrow = now.add(1, 'day').startOf('day');
    const msUntilMidnight = tomorrow.diff(now);
    const hoursUntilMidnight = Math.round(msUntilMidnight / 1000 / 60 / 60);
    clientLogger.info({ message: 'Setting initial date transition timeout', hoursUntilMidnight });

    // Set initial timeout
    let timeout = setTimeout(checkDateTransition, msUntilMidnight);

    return () => clearTimeout(timeout);
  }, [timezone, onTransition]);
}
